(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["stripe-banner"]) return;
  try {
    
/* Optional: Add section-specific JS here; it will scope to this section instance */

  } catch(e) { console.error(e); }
})();
})();
